export const WRONG_OTP_ERROR_CODE = '1201010';
